import { takeLatest, put, call } from "redux-saga/effects";
import { client } from "../apollo-client";
import { FetchModifierAction } from "./types";
import { GET_MODIFIERS, GET_MODIFIER } from "./mutations";
import { setModifiers } from "./reducer";

function* fetchModifier(action: FetchModifierAction) {
  try {
    yield put({ type: "SET_LOADING" });
    const { data } = yield call(client.query, {
      query: GET_MODIFIER,
      variables: { input: action.payload },
    });
    yield put({ type: "SET_MODIFIER", payload: data.modifier });
  } catch (error: any) {
    yield put({ type: "SET_ERROR", payload: error.message });
  }
}

function* fetchModifiersSaga(): Generator<any, void, any> {
  try {
    const {
      data: { modifiers },
    } = yield call([client, client.query], {
      query: GET_MODIFIERS,
      variables: {
        input: {},
      },
    });
    yield put(setModifiers(modifiers));
  } catch (error) {
    console.error(error);
  }
}

export function* modifierSaga() {
  yield takeLatest("FETCH_MODIFIER", fetchModifier);
  yield takeLatest("FETCH_MODIFIERS", fetchModifiersSaga);
}
